import moment from "moment";

const state = {
    orderHotel: [],
    commentHotel:[
        {   comment_id:1,
            actions: ['Reply to'],
            author: '爱吃鱼的小鱼仔',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=317222343,3377382520&fm=15&gp=0.jpg',
            content:
                '完全是超出我的预期的.为了去乍都乍周末市场才住在vic3的，相对来说近一点方便打车.结果，这个价位到了大堂眼前是一亮啊～有泳池有健身房，楼下还有咖啡店，门口睡莲的盆里还有很可爱的不知名小鱼仔.安全性能也蛮好的，要刷房卡才可以使用电梯.非常推荐这家\n',
            datetime: moment().subtract(1, 'days'),
            commentTo:"上海锦江都城经典南京东路外滩酒店"
        },
        {   comment_id:2,
            actions: ['Reply to'],
            author: '卖面在买面',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3498411211,779529348&fm=15&gp=0.jpg',
            content:
                '酒店和图片一样的，但房间比较小，去所有景点都可以轻轨和地铁，可以买3日的联票280，酒店出门左边行大约10分钟有几家吃饭的，也不贵!千万不要叫的士，你可以打表，但15分钟的路程帮我兜了1个小时\n',
            datetime: moment().subtract(2, 'days'),
            commentTo:"上海锦江都城经典南京东路外滩酒店"
        },
        {   comment_id:3,
            actions: ['Reply to'],
            author: '爱哭的小朋友不乖哦',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3498411211,779529348&fm=15&gp=0.jpg',
            content:
                '酒店很不错',
            datetime: moment().subtract(2, 'days'),
            commentTo:"上海和平饭店"
        },
        {
            comment_id:4,
            actions: ['Reply to'],
            author: '爱吃鱼的小鱼仔',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=317222343,3377382520&fm=15&gp=0.jpg',
            content:
                '完全是超出我的预期的.为了去乍都乍周末市场才住在vic3的，相对来说近一点方便打车.结果，这个价位到了大堂眼前是一亮啊～有泳池有健身房，楼下还有咖啡店，门口睡莲的盆里还有很可爱的不知名小鱼仔.安全性能也蛮好的，要刷房卡才可以使用电梯.非常推荐这家\n',
            datetime: moment().subtract(1, 'days'),
            commentTo:'【自由行】亚龙湾'
        },
        {
            comment_id:5,
            actions: ['Reply to'],
            author: '卖面在买面',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3498411211,779529348&fm=15&gp=0.jpg',
            content:
                '酒店和图片一样的，但房间比较小，去所有景点都可以轻轨和地铁，可以买3日的联票280，酒店出门左边行大约10分钟有几家吃饭的，也不贵!千万不要叫的士，你可以打表，但15分钟的路程帮我兜了1个小时\n',
            datetime: moment().subtract(2, 'days'),
            commentTo:'【半自助游】海南三亚6日5晚半自助游'
        },
        {   comment_id:6,
            actions: ['Reply to'],
            author: '张三',
            avatar: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=3498411211,779529348&fm=15&gp=0.jpg',
            content:
                '酒店很不错，牛啊牛啊牛啊牛啊牛啊',
            datetime: moment().subtract(2, 'days'),
            commentTo:"曼谷威客3号酒店（原曼谷胜利纪念碑全季酒店）"
        },
    ],
    dataRelated: [
        {
            author: '热心的不知名网友',
            avatar: 'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2851959424,1940728968&fm=15&gp=0.jpg',
            content:
                '地理位置极佳，酒店其实屋顶就是个景点，83层旋转观景台，一览城市风光，入住酒店可以免费观景。酒店的自助餐和水果自助餐都不错，' +
                '关键是价格还便宜，一般房间40ORMB左右，性价比高，唯一不足就是设施有点陈日，酒店的大门实在是太小了，旁边就是街边夜市。\n',
            datetime: moment().subtract(1, 'days'),
            level:4.5,
            relate:"《上海迪士尼亲子游2018.7（含FP错误使用案例）》",
            href:"http://www.mafengwo.cn/i/9883046.html",
            travelEditTo:"上海锦江都城经典南京东路外滩酒店"
        },
        {
            author: '八厘米的米粒',
            avatar: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2440380342,2415710444&fm=26&gp=0.jpg',
            content:
                '定这家酒店的初衷是想带我妈体验一把土壕的生活，价格也在我接受范围内，而且这家酒店就是第一高楼，大年初一是我妈生日，在这度过，感觉别有意义。酒店的位置离暹罗广场和皇权免税店都不远，有免费班车去暹罗，走路去皇权15-\n' +
                '20分钟。装修偏老式，但房间超级超级超级大，晚上拉开窗帘就能看到美丽的城市夜景。\n',
            datetime: moment().subtract(2, 'days'),
            level:5,
            relate:"《情迷上海滩——一段极度复古的别样旅程》 ",
            href:"http://www.mafengwo.cn/i/6958850.html",
            travelEditTo:"上海锦江都城经典南京东路外滩酒店"
        },
    ],
    hotelData: [
        //主题住宿
        {
            hotel_id: 1,
            title: `奥兰多精品度假酒店`,
            src: 'https://z1.muscache.cn/im/pictures/20fa4ef4-44e5-4ece-b18e-067f02645385.jpg?aki_policy=large',
            description: 'Ant Design, a design language for background applications, is refined by Ant UED Team.',
            address: '地址：美国奥兰多',
            cityName: "奥兰多",
            comments: { text: "评价", total: 121 },
            collection: { text: "收藏", total: 3884 },
            buy: { text: "已订购", total: 25 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 2,
            title: `奥兰多舒适酒店`,
            src: 'https://z1.muscache.cn/im/pictures/f3913158-fa84-4944-a257-aa5f6a29a0e7.jpg?aki_policy=large',
            description: '舒适型,cations, is refined by Ant UED Team.',
            address: '地址：We supply a etch and A and efficiently.',
            cityName: "奥兰多",
            comments: { text: "评价", total: 285 },
            collection: { text: "收藏", total: 4772 },
            buy: { text: "已订购", total: 25 },
            hotelLevel: 4,priceLow:120,priceHigh:700,
        },
        {
            hotel_id: 2,
            title: `奥兰多经济酒店`,
            src: 'https://z1.muscache.cn/im/pictures/7247f04f-cd8f-4667-899d-56ea9fb2ceb6.jpg?aki_policy=large',
            description: 'Ant Design, a design language for background applicas refined by Ant UED Team.',
            address: '地址：We supply a series of design pr prototypes.',
            cityName: "奥兰多",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 3.5,priceLow:100,priceHigh:650,
        },
        {
            hotel_id: 2,
            title: `奥兰多柏聂特溪度假村`,
            src: 'http://n1-q.mafengwo.net/s6/M00/52/1F/wKgB4lMlWAKATaRbAAJrMQHyd_w88.jpeg?imageMogr2%2Fthumbnail%2F%21660x480r%2Fgravity%2FCenter%2Fcrop%2F%21660x480%2Fquality%2F90',
            description: 'Orlando Bonnet Creek Resort',
            address: '地址：9560 Via Encinas, Lake Buena Vista, 奥兰多, FL 32830.',
            cityName: "奥兰多",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 3.5,priceLow:100,priceHigh:650,
        },

        {
            hotel_id: 4,
            title: `上海锦江都城经典南京东路外滩酒店`,
            src: 'https://p1-q.mafengwo.net/s10/M00/1B/3E/wKgBZ1mbFTqATyxmACl3qM_XDqI24.jpeg?imageMogr2%2Fthumbnail%2F%211360x940r%2Fgravity%2FCenter%2Fcrop%2F%211360x940%2Fquality%2F90',
            description: '地理位置好，和平饭店隔壁，距离外滩只有200多米距离；',
            address: '地址：南京东路98号',
            cityName: "上海",
            comments: { text: "评价", total: 157 },
            collection: { text: "收藏", total: 2884 },
            buy: { text: "已订购", total: 33 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 5,
            title: `上海和平饭店`,
            src: 'https://p1-q.mafengwo.net/s10/M00/F8/0A/wKgBZ1mMQJqAHUtTAAxvxmYJ6SY83.jpeg?imageMogr2%2Fthumbnail%2F%211360x940r%2Fgravity%2FCenter%2Fcrop%2F%211360x940%2Fquality%2F90',
            description: '奢华客房及套房，配备了结合装饰艺术主义风格的家具和现代化生活设施',
            address: '地址：南京东路20号',
            cityName: "上海",
            comments: { text: "评价", total: 123 },
            collection: { text: "收藏", total: 4566 },
            buy: { text: "已订购", total: 45 },
            hotelLevel: 4,priceLow:120,priceHigh:700,
        },
        {
            hotel_id: 6,
            title: `苏荷精选花园别墅酒店(上海交通大学地铁站旗舰店)`,
            src: 'https://https://b1-q.mafengwo.net/s2/M00/D6/C9/wKgIDFt8FK-ALplGAAPXOE1x04k67.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90.muscache.cn/im/pictures/7247f04f-cd8f-4667-899d-56ea9fb2ceb6.jpg?aki_policy=large',
            description: '老洋房，复古，老上海',
            address: '地址：泰安路115弄9号',
            cityName: "上海",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 3.5,priceLow:100,priceHigh:650,
        },
        {
            hotel_id: 7,
            title: `香港中环迷你酒店`,
            src: 'https://b1-q.mafengwo.net/s6/M00/15/88/wKgB4lMQN4yARrwLAADDoDjZhVU50.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Mini Hotel Central',
            address: '中环雪厂街三十八号',
            cityName: "香港",
            comments: { text: "评价", total: 157 },
            collection: { text: "收藏", total: 2884 },
            buy: { text: "已订购", total: 33 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 8,
            title: `香港港丽酒店`,
            src: 'https://b1-q.mafengwo.net/s17/M00/4C/5C/CoUBXl_E_COAcDwqAAgfSaPunXc88.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Conrad Hong Kong',
            address: '地址：金钟道88号太古广场',
            cityName: "香港",
            comments: { text: "评价", total: 123 },
            collection: { text: "收藏", total: 4566 },
            buy: { text: "已订购", total: 45 },
            hotelLevel: 4,priceLow:120,priceHigh:700,
        },
        {
            hotel_id: 9,
            title: `香港园景轩`,
            src: 'https://n1-q.mafengwo.net/s10/M00/7A/24/wKgBZ1mIQG-AFSgnAAFn9_or4tc11.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Garden View Hong Kong',
            address: '地址：中环麦当劳道一号',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 3.5,priceLow:100,priceHigh:650,
        },
        // 曼谷
        {
            hotel_id: 10,
            title: `曼谷威客3号酒店（原曼谷胜利纪念碑全季酒店）`,
            src: 'http://n1-q.mafengwo.net/s11/M00/97/56/wKgBEFsjNU6ADk6NAAIXJnPqJIM73.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Vic3 Bangkok',
            address: '89 Phahon Yothin Soi 3, Phaya Tha',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 11,
            title: `穰南帝景酒店`,
            src: 'http://b1-q.mafengwo.net/s11/M00/7D/D8/wKgBEFsY872AdeVPAAIR_MMohbg08.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Royal View Resort - Rang Nam',
            address: '27/3 Soi Rajawithi 3 Rangnam Road, Phayathai, Rach...',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 12,
            title: `璀璨专享服务公寓`,
            src: 'http://p1-q.mafengwo.net/s7/M00/3F/78/wKgB6lR0t0iAfpAdAANZ56tPKao53.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Abloom Exclusive Serviced Apartments',
            address: '5/36 Phaholyothin Soi 3',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.0,
        },
        {
            hotel_id: 13,
            title: `曼谷暹罗安纳塔拉酒店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/DE/AC/wKgBZ1mINF6ADiZKAAMQRMi1Wy411.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Anantara Siam Bangkok Hotel',
            address: '155 Rajadamri Road, Siam',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 14,
            title: `彩虹云霄酒店`,
            src: 'http://b1-q.mafengwo.net/s9/M00/1E/47/wKgBs1hJJ1OANkS8AAevVMGRJoE36.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Baiyoke Sky Hotel',
            address: '222 Rajprarop Road, Rajthevi',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 15,
            title: `曼谷利特酒店`,
            src: 'http://b1-q.mafengwo.net/s17/M00/4F/8C/CoUBXl9wTYKAKDHAAFomj0uUFWo63.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'LiT BANGKOK Residence',
            address: '36/1 Soi Kasemsan 1, Rama I Rd., Wangmai, Pathumwa',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 16,
            title: `暹罗四季酒店`,
            src: 'http://p1-q.mafengwo.net/s11/M00/22/75/wKgBEFsg2XmAG8zXAF50lnItD1A79.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Seasons Siam Hotel',
            address: '97 Rajaprarop Rd., Makkasan,Rajatavee',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 17,
            title: `曼谷廊曼机场阿玛瑞酒店`,
            src: 'http://n1-q.mafengwo.net/s6/M00/93/D3/wKgB4lMDU3iAMLEGAAJejjVcGGU69.jpeg?imageMogr2%2Fthumbnail%2F%21480x480r%2Fgravity%2FCenter%2Fcrop%2F%21480x480%2Fquality%2F90',
            description: 'Amari Don Muang Airport Bangkok',
            address: '333 Chert Wudthakas Road, Don Muang',
            cityName: "曼谷",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        //台北
        {
            hotel_id: 18,
            title: `台北凯撒大饭店`,
            src: 'http://n1-q.mafengwo.net/s11/M00/D8/47/wKgBEFxOrtSAGtsBAAOSdqF0TAE64.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Caesar Park Hotel Taipei',
            address: '忠孝西路一段38号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 19,
            title: `台北大师商旅`,
            src: 'http://n1-q.mafengwo.net/s10/M00/62/AF/wKgBZ1n27yCALeTjAAHbXAuSYEc29.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Master Hotel',
            address: '市民大道一段209号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 20,
            title: `台北君品酒店`,
            src: 'http://p1-q.mafengwo.net/s10/M00/5A/13/wKgBZ1n25jOAOLTQAAPmEiuCYc439.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Palais de Chine Hotel',
            address: '承德路一段3号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 21,
            title: `台北帅客旅店`,
            src: 'http://b1-q.mafengwo.net/s10/M00/87/E0/wKgBZ1mMhHWAA2RDAArXrdKFAhw93.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Saual Keh Hotel',
            address: '罗斯福路一段90巷2号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 3.5,priceLow:100,priceHigh:650,
        },
        {
            hotel_id: 22,
            title: `台北二十轮旅店西门町馆`,
            src: 'http://n1-q.mafengwo.net/s6/M00/C6/FB/wKgB4lMYBBSADTDLAAHznk7MmSU50.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'SWIIO Hotel Ximending',
            address: '武昌街二段72号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 23,
            title: `台北皇家季节酒店-南西馆`,
            src: 'http://n1-q.mafengwo.net/s7/M00/2A/F7/wKgB6lR0oqiAZZzfAAGCjyiijks07.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Royal Seasons Hotel Taipei Nanjing W',
            address: '南京西路326号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.0,
        },
        {
            hotel_id: 24,
            title: `台北一乐园大饭店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/75/7D/wKgBZ1mMpLCAbRdZAADLhfZ9gLg25.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Onetel Taipei',
            address: '西宁南路24号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 25,
            title: `台北王朝大酒店`,
            src: 'http://b1-q.mafengwo.net/s16/M00/34/62/CoUBUl_QLV2ANPR1AAJnioxv1Rc07.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Sunworld Dynasty Hotel Taipei',
            address: '敦化北路100号',
            cityName: "台北",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        //东京
        {
            hotel_id: 26,
            title: `东京湾希尔顿酒店`,
            src: 'http://b1-q.mafengwo.net/s16/M00/34/62/CoUBUl_QLV2ANPR1AAJnioxv1Rc07.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Hilton Tokyo Bay',
            address: '1-8, Maihama, rayasu-shi,东京迪斯尼乐园地区,浦安市,千叶县,日本',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 27,
            title: `东京京王广场酒店`,
            src: 'http://b1-q.mafengwo.net/s13/M00/A5/70/wKgEaVyR-s-AI8QLAAHU0eFcDdc92.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Keio Plaza Hotel Tokyo',
            address: 'Shinjuku-ku, Nishishinjuku 2-2-1',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 28,
            title: `日晖新宿酒店`,
            src: 'http://n1-q.mafengwo.net/s7/M00/F9/17/wKgB6lR0gkmAMrY3AAEyTu8Pk9873.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Hotel Sunlite Shinjuku',
            address: 'Shinjuku-ku, Shinjuku 5-15-8',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 29,
            title: `东京湾喜来登大酒店`,
            src: 'http://p1-q.mafengwo.net/s7/M00/8D/9B/wKgB6lR1KVOAWyObAAJkMc8GP4k55.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Sheraton Grande Tokyo Bay Hotel',
            address: '千葉県浦安市舞浜1-9',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 30,
            title: `东新宿E酒店`,
            src: 'http://n1-q.mafengwo.net/s16/M00/7E/3E/CoUBUl592HqAONySAAFjOiUESt879.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'E Hotel Higashi Shinjuku',
            address: 'Shinjuku-ku, Kabukicho 2-3-15',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 31,
            title: `馨乐庭中央东京新宿区酒店`,
            src: 'http://n1-q.mafengwo.net/s9/M00/D3/43/wKgBs1aKTiiAc-LDAAGR5PqxWak08.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Citadines Central Shinjuku Tokyo',
            address: 'Shinjuku-ku, Kabuki-Cho 1-2-9',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 32,
            title: `东京新宿馨乐庭酒店`,
            src: 'http://p1-q.mafengwo.net/s11/M00/FF/7B/wKgBEFq7eaOAVLnsAAEyFcMydlA54.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Citadines Shinjuku Tokyo',
            address: 'Shinjuku-ku, Shinjuku 1-28-13',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 33,
            title: `新宿灿路都广场大饭店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/BB/3F/wKgBZ1mIciOABAHCAAG3N4y4X1I65.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: 'Hotel Sunroute Plaza Shinjuku',
            address: 'Shibuya-ku, Yoyogi 2-3-1',
            cityName: "东京",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        //香港
        {
            hotel_id: 34,
            title: `迪士尼好莱坞酒店`,
            src: 'http://b1-q.mafengwo.net/s10/M00/46/D4/wKgBZ1xOu3eAPq4oAAJx3K67Ea465.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Disney's Hollywood Hotel",
            address: '大屿山香港迪士尼乐园度假区',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 35,
            title: `香港迪士尼乐园酒店`,
            src: 'http://b1-q.mafengwo.net/s11/M00/47/42/wKgBEFtMOoOARhjSAFu0aSokGPg74.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Hong Kong Disneyland Hotel",
            address: '大屿山香港迪士尼乐园度假区',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 36,
            title: `香港珀丽酒店`,
            src: 'http://b1-q.mafengwo.net/s10/M00/CB/56/wKgBZ1mIMTqAP-DoAAHuhx7bH9M15.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Rosedale Hotel Hong Kong",
            address: '铜锣湾信德街8号',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 37,
            title: `香港憙酒店`,
            src: 'http://b1-q.mafengwo.net/s6/M00/F1/EB/wKgB4lMQIXSAeIzHAAFHkc2g-wI33.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Xi Hotel",
            address: '尖沙咀棉登径七号',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 38,
            title: `香港英格兰豪华客栈`,
            src: 'http://p1-q.mafengwo.net/s2/M00/0C/61/wKgBpU42hhbH2j-2AAHiXRKD6Ts40.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "UK Hostel",
            address: '九龙尖沙咀弥敦道36-44号重庆大厦A座3字楼...',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 39,
            title: `红茶馆酒店-土瓜湾邮轮码头店`,
            src: 'http://b1-q.mafengwo.net/s6/M00/E4/EB/wKgB4lMYGh-AEjAqAACcymmkrLQ77.jpeg?imageMogr2%2Fthumbnail%2F%21480x480r%2Fgravity%2FCenter%2Fcrop%2F%21480x480%2Fquality%2F90',
            description: "Bridal Tea House To Kwa Wan Cruise Terminal Hotel",
            address: '九龙尖沙咀弥敦道36-44号重庆大厦A座3字楼...',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 40,
            title: `香港J Plus 精品酒店`,
            src: 'http://b1-q.mafengwo.net/s10/M00/67/27/wKgBZ1mIF2GAISpbAALt22pc_I089.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "J Plus Hotel by YOO",
            address: '铜锣湾伊荣街1-5号',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 41,
            title: `香港Casa酒店`,
            src: 'http://b1-q.mafengwo.net/s12/M00/7A/34/wKgED1wgQOGAHF5jAAds4PihBeY29.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Casa Hotel",
            address: '九龙油麻地弥敦道487-489号',
            cityName: "香港",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        //首尔
        {
            hotel_id: 42,
            title: `中央明洞空中公園酒店`,
            src: 'http://p1-q.mafengwo.net/s9/M00/41/B6/wKgBs1Zv7XWAc79kAAIzMeLYaXc67.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Hotel Skypark Central Myeongdong",
            address: '16, Myeongdong 9-gil, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 43,
            title: `空中花园酒店明洞1号店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/C7/50/wKgBZ1mMjKOAUUMqAAHcxPQNWeg96.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Hotel Skypark Myeongdong 1",
            address: '15, Myeongdong 8na-gil, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 44,
            title: `明洞韦斯廷居住酒店`,
            src: 'http://b1-q.mafengwo.net/s12/M00/AB/33/wKgED1ukoP2AGs8mAAPz61feA7U12.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Vestin Residence Myeongdong",
            address: '10, Toegye-ro 24-gil, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 45,
            title: `天空花园酒店东大门1号店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/B0/A4/wKgBZ1ngelyADHJxAAMwDwj0Q2o71.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Hotel Skypark Dongdaemun I",
            address: '335, Dongho-ro, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 46,
            title: `宜必思仁寺洞大使酒店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/72/96/wKgBZ1mIpiSAcRypAAJznF3r1pw22.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "ibis Ambassador Insadong",
            address: '31, Samil-daero 30-gil, Jongno-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 47,
            title: `太平洋酒店`,
            src: 'http://p1-q.mafengwo.net/s10/M00/05/DF/wKgBZ1n8M9aAa7NCAAj_s7HNmPc28.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Pacific Hotel",
            address: '2, Toegye-ro 20-gil, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 48,
            title: `首尔大使铂尔曼酒店`,
            src: 'http://p1-q.mafengwo.net/s11/M00/E5/3C/wKgBEFs2DLuAYe13ACKW5d3Mu8k89.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Grand Ambassador Seoul associated with Pullman",
            address: '287, Dongho-ro, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 49,
            title: `首尔东大门大使宜必思快捷酒店`,
            src: 'http://n1-q.mafengwo.net/s10/M00/C4/05/wKgBZ1onZr6APWVDAAGb4QRKL3809.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "ibis Budget Ambassador Seoul Dongdaemun",
            address: '334, Toegyero, Jung-gu',
            cityName: "首尔",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        //新加坡
        {
            hotel_id: 50,
            title: `新加坡港湾彩鸿酒店 (Staycation Approved)`,
            src: 'http://b1-q.mafengwo.net/s10/M00/88/D7/wKgBZ1mIbHeAXwSbAAFfGqSIyro03.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Travelodge Harbourfront Singapore (SG Clean)",
            address: '50 Telok Blangah Road,港湾站地区新加坡',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 51,
            title: `新加坡滨海湾金沙大酒店 (Staycation Approved)`,
            src: 'http://p1-q.mafengwo.net/s17/M00/21/05/CoUBXl_rg7-AJuNuABGyoV7_ftA93.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Marina Bay Sands (SG Clean)",
            address: '10 Bayfront Avenue, 滨海湾, 新加坡',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 52,
            title: `客莱福 33 惹兰苏丹酒店`,
            src: 'http://n1-q.mafengwo.net/s12/M00/F0/F4/wKgED1upjeKACHbQAAWA6Wrl0o086.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Hotel Clover 33 Jalan Sultan",
            address: '33 Jalan Sultan,武吉士地区,新加坡',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 53,
            title: `新加坡克拉码头智选假日酒店(SG Clean)`,
            src: 'http://n1-q.mafengwo.net/s16/M00/3B/A6/CoUBUl6jpIWAffnEAAx80rXS_Vo46.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Holiday Inn Express Singapore Clarke Quay (SG Clean)",
            address: '2 Magazine Road',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 54,
            title: `新加坡飞龙酒店-玫瑰 (Staycation Approved)`,
            src: 'http://b1-q.mafengwo.net/s9/M00/C1/C9/wKgBs1aAKnWAU-6_AAEMxfUuTi406.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Fragrance Hotel - Rose (SG Clean)",
            address: '263 Balestier Road',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 55,
            title: `新加坡宜必思快捷店-西海岸 (Staycation Approved)`,
            src: 'http://b1-q.mafengwo.net/s9/M00/BC/7F/wKgBs1c0P9uAfBSuAAHfFXiBKg883.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Ibis Budget Singapore West Coast (SG Clean)",
            address: '418 Pasir Panjang Road',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 56,
            title: `新加坡香格里拉圣淘沙度假村 (Staycation Approved)`,
            src: 'http://n1-q.mafengwo.net/s16/M00/36/F2/CoUBUl7qAYeAAfT9AK0iwynnTbE14.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Shangri-La's Rasa Sentosa Resort & Spa (SG Clean)",
            address: '101 Siloso Road',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 57,
            title: `新加坡丽思卡尔顿美年酒店 (Staycation Approved)`,
            src: 'http://b1-q.mafengwo.net/s11/M00/5E/74/wKgBEFsH23KAbsFnAAJSEYqrAFk27.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: "Shangri-La's Rasa Sentosa Resort & Spa (SG Clean)",
            address: '7 Raffles Avenue, 滨海湾, 039799 新加坡',
            cityName: "新加坡",
            comments: { text: "评价", total: 1877 },
            collection: { text: "收藏", total: 1877 },
            buy: { text: "已订购", total: 17 },
            hotelLevel: 4.5,priceLow:150,priceHigh:850,
        },
        {
            hotel_id: 58,
            title: `上海豪华五星级酒店`,
            src: 'http://b1-q.mafengwo.net/s11/M00/5E/74/wKgBEFsH23KAbsFnAAJSEYqrAFk27.jpeg?imageMogr2%2Fthumbnail%2F%211360x760r%2Fgravity%2FCenter%2Fcrop%2F%211360x760%2Fquality%2F90',
            description: '奢华客房及套房，配备了结合装饰艺术主义风格的家具和现代化生活设施',
            address: '地址：上海滨海湾20号',
            cityName: "上海",
            comments: { text: "评价", total: 1523 },
            collection: { text: "收藏", total: 14566 },
            buy: { text: "已订购", total: 1145 },
            hotelLevel: 5,priceLow:300,priceHigh:1000,
        },
    ],
    goodData:[],//点击后跳转详情的数据
    goodThidData:[], //收藏的数据

    travelData:
        [
        {
            hotel_id:1,
            name:'三亚',
            title: `【自由行】亚龙湾`,
            src: 'http://n1-q.mafengwo.net/s8/M00/7D/0F/wKgBpVYDauaALeUWABF5LAsi7SE63.jpeg?imageMogr2%2Fthumbnail%2F%21310x206r%2Fgravity%2FCenter%2Fcrop%2F%21310x206%2Fquality%2F90%7Cwatermark%2F1%2Fimage%2FaHR0cDovL2IxLXEubWFmZW5nd28ubmV0L3MxMS9NMDAvNDQvOUIvd0tnQkVGc1A1UnlBRHY3cEFBQUhaWlVQUmxROTkwLnBuZw%3D%3D%2Fgravity%2FSouthEast%2Fdx%2F10%2Fdy%2F11',
            description:
                '“足不出国”欣赏热带海岛风光的不二选择！' +
                '三亚地处海南岛最南端，是“足不出国”欣赏热带海岛风光的不二选择。对于首次到访的游客，建议安排4-5天游玩；若有计划再前往附近离岛，则需要多花费1-2天。' +
                '由于主要景点自西至东散布于三亚湾、大东海、亚龙湾和海棠湾这四个区域内，加上交通的不太便捷，如何在有限的时间内玩转三亚，需要合理的规划。',
            tips:['美食','探险','境内游']
        },
        {
            hotel_id:2,
            name:'三亚',
            title: `【半自助游】海南三亚6日5晚半自助游`,
            src: '//dimg04.c-ctrip.com/images/0302x1200085ky026B5DE_D_769_510_Q100.jpg',
            description:
                '『国际品牌酒店可任选·连住or双湾全体验｜A线福利加赠红树林水乐园门票』海南四大名菜&天堂森林公园自助餐｜嗨玩蜈支洲岛+VIP免排队通道｜24H专车接送·三亚机场休息室' +
                '三亚地处海南岛最南端，是“足不出国”欣赏热带海岛风光的不二选择。对于首次到访的游客，建议安排4-5天游玩；若有计划再前往附近离岛，则需要多花费1-2天。' ,
            tips:['精致小团','无购物','森林']
        },
        {
            hotel_id:3,
            name:'三亚',
            title: `【跟团游】海南三亚5日4晚跟团游`,
            src: '//dimg04.c-ctrip.com/images/0303g1200084vpudwC093_D_769_510_Q100.jpg',
            description:
                '直升机+潜水+游艇（含摩托艇+海钓+水果小吃）+天堂森林公园（含全景玻璃栈道）+蜈支洲+南山108米海上观音' +
                '品牌喜来登/万豪/一线五星海景房任选，EF线升级10人精致团' +'『海鲜餐+椰子鸡』',
            tips:['成团保障','无购物','森林']
        },
        {
            hotel_id:1,
            name:'重庆',
            title: `【自由行】探索长江源`,
            src: 'http://b1-q.mafengwo.net/s9/M00/A7/62/wKgBs1fJRg2AUXH9AB2F0_VO-gQ60.jpeg?imageMogr2%2Fthumbnail%2F%211020x540r%2Fgravity%2FCenter%2Fcrop%2F%211020x540%2Fquality%2F100',
            description:
                '青藏高原上，冰雪融化于高山，汇成沱沱河，向东万里，成为中国人的母亲河。逆流溯源长江是一次朝圣之旅，沿途可见“最中国”的历史人文与极致风光，但3400km 的超长里程，复杂交通，和高原爬升注定这是一场勇敢者的探索之旅，也因此自驾车溯源长江，是所有旅行方式中最高效，最能将沿江美景尽收眼底的选择。 本篇攻略，我们将为旅行者提供有关长江溯源的行前准备、自驾路线、驾驶安全等方面的信息，其中自驾路线以长江中游的武汉为起点，途径 三峡库区、重庆、G318，直抵长江源头，为自驾旅行爱好者带来新的 思路与实质帮助。',
            tips:['自驾','三峡','重庆']
        },
        {
            hotel_id:2,
            name:'重庆',
            title: `【自助游】勒是雾都|重庆三日游攻略`,
            src: 'http://b1-q.mafengwo.net/s16/M00/0D/6C/CoUBUl8qx1GASWRQAA4pwTutXJ0324.JPG',
            description:
                '去重庆 ，就是现在！在一个极其平凡的日子我脑海里突然跳出这个念头，于是便有了这次旅行。'+
                '重庆的洪崖洞，由吊脚楼和仿古商业街等景观组成的立体式空中步行街景区，长1.2公里，高达11层楼。' ,
            tips:['自由行','双人行']
        },
        {
            hotel_id:3,
            name:'重庆',
            title: `【自助游】洪崖洞民俗风貌区`,
            src: '//http://n1-q.mafengwo.net/s10/M00/13/D1/wKgBZ1zrXemAOYk-AAznLMQ3ipk203.jpg?imageMogr2%2Fthumbnail%2F%21690x370r%2Fgravity%2FCenter%2Fcrop%2F%21690x370%2Fquality%2F100.c-ctrip.com/images/0303g1200084vpudwC093_D_769_510_Q100.jpg',
            description:
                '直升机+潜水+洪崖洞民俗风貌区作为国家级AAAA旅游风景区，是小天鹅集团投资修建的目前市中心唯一一片展现巴渝传统民俗风貌区域。'+'请有前往计划的游客朋友，提前搜索官方公众号——“洪崖洞”，进入页面后点击左下角“预约取票”，根据行程安排，提前领取免费电子入场券，现场验券入园。',
            tips:['当地特色','无购物','一天、一晚']
        },
        {
            hotel_id:1,
            name:'丽江',
            title: `【婚纱旅拍】天赐美景-彩云之南`,
            src: 'http://b1-q.mafengwo.net/s9/M00/A7/62/wKgBs1fJRg2AUXH9AB2F0_VO-gQ60.jpeg?imageMogr2%2Fthumbnail%2F%211020x540r%2Fgravity%2FCenter%2Fcrop%2F%211020x540%2Fquality%2F100',
            description:
                '风花雪月地，山色水光城，形容的应该就是云南 了吧'+'这个让很多人都还魂梦牵绕的地方'+'是我选择婚拍的目的地',
            tips:['度蜜月','旅拍','云南']
        },
        {
            hotel_id:2,
            name:'丽江',
            title: `【自助游】彩云之南丨丽江`,
            src: 'http://p1-q.mafengwo.net/s16/M00/F6/8F/CoUBUl_bCNGAK8JtAAEL1f5Yzdk49.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                '去年九月的 青海 - 甘肃 大环线之旅，记忆犹新。每当想起 青海湖 的画面，都想让心灵再次去流浪。今年利用年假的时间，选择去我的众多旅行规划地之一———— 云南 。'+
                '这是和海艳的第一次远途旅行，关于 云南 的美食景点、路线规划，出游前我在马蜂窝上做足了功课。由于不想坐太长时间的车，只想让身心放松，泸沽湖、 香格里拉 等热门目的地就没去，而只选择了 丽江 和 大理 两地。' ,
            tips:['自由行','双人行']
        },
        {
            hotel_id:3,
            name:'丽江',
            title: `【自助游】丽江大理泸沽湖打卡记`,
            src: 'http://p1-q.mafengwo.net/s15/M00/5B/E8/CoUBGV4Fy2CAM-eVABTDCaG3aIc800.jpg?imageMogr2%2Fthumbnail%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90',
            description:
                '这篇游记躺在硬盘里面也够久的了，想想今年疫情哪里也去不了了，也就国内可能相对来说可以能走上一走了，翻出硬盘把照片整理一下，上传蜂窝后没有再码字，没想到这一耽搁又是快小半年了。今天有空，接着写一点， 云南 相对很多人并不陌生，国内游的热门景区，无论是跟团或是自驾，都能饱览美丽的风景。除了 玉龙雪山 、 香格里拉 和 梅里雪山 ，基本上没有高反的困扰，如今的高速修建，也使得路途没有了曾经的颠簸。',
            tips:['泸沽湖','5天']
        },
        {
            hotel_id:1,
            name:'广州',
            title: `【广州365天】请签收一份四季的味道 · 七彩的斑斓`,
            src: 'https://n1-q.mafengwo.net/s16/M00/CB/76/CoUBUl_ayBqAZGeXAADD9U_uTc433.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                '周末在家长蘑菇了一个多月的我，压制不住想要出去走走的心，终于戴上“新同伴”--口罩，还有老伙伴相机出门，探寻下2020年不一样的 广州 ，会有什么新发现！'+'现在不能去远行，不如放慢这奇遇旅程中的步伐，来个中间歇息的时刻，发掘生活城市中的点滴美好吧！所有美好都会随春风款款而来，我攒了好多有趣的地方，跟着我的脚步，现在就说给你听～',
            tips:['当地人','本土特色']
        },
        {
            hotel_id:2,
            name:'广州',
            title: `【西关】宝藏级西关打卡攻略`,
            src: 'https://b1-q.mafengwo.net/s17/M00/09/8D/CoUBXl_25JKASYNNAAyGIveXcDU399.jpg?imageMogr2%2Fthumbnail%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90',
            description:
                '说到80后和90后的集体回忆恒宝广场绝对算得上是其中之一每次来游西关，都会先坐地铁到 长寿 路站从恒宝广场出发，开始“逛吃逛吃”之旅' ,
            tips:['自由行','双人行']
        },
        {
            hotel_id:3,
            name:'广州',
            title: `【广佛一日游】这几个地方一定要去！`,
            src: 'http://p1-q.mafengwo.net/s15/M00/5B/E8/CoUBGV4Fy2CAM-eVABTDCaG3aIc800.jpg?imageMogr2%https://b1-q.mafengwo.net/s17/M00/FC/E4/CoUBXmAS0-GABghOAAT_xZ_oHFY010.jpg?imageMogr2%2Fthumbnail%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90',
            description:
                '今年，随着各大航司陆续推出“随心飞”、“无限飞”、“安心飞”等飞行套餐，让憋坏的大家终于有了说走就走的理由。但，机票的诸多限制让出行计划显得有些仓促，如何才能安排一场真正舒适的“随心飞、安心飞”，让原本匆忙的旅行慢下来？',
            tips:['广佛一日游','儿童乐园，打卡地']
        },
        {
            hotel_id:1,
            name:'桂林',
            title: `【自由行】桂林自由行三日游，好山好水好悠闲`,
            src: 'https://n1-q.mafengwo.net/s16/M00/CB/76/CoUBUl_ayBqAZGeXAADD9U_uTc433.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                '以漓江风光和喀斯特地貌为盛名的桂林早已烂熟于心，那，满城桂花香的味道你可闻到？地道酸萝卜搭配最正宗的桂林米粉你可尝到？这样如何——清晨早起，和本地人一样，品最地道的桂林米粉，赏最经典的漓江景致；上月亮山，爬到台阶的尽头看近处的月亮岩，俯瞰整个阳朔的山峰，尤其太阳下山时分，山脚缠绕一团烟雾，如仙境般美轮美奂。旅行就是要发现当地人漠视的美景！',
            tips:['日月双塔','象鼻山']
        },
        {
            hotel_id:2,
            name:'桂林',

            title: `【西关】桂林阳朔`,
            src: 'https://b1-q.mafengwo.net/s16/M00/62/EC/CoUBUl_iwsuATu-fAAHGQTrv6x406.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                '“ 桂林 山水甲日下, 玉碧罗青意可参. ”' +'疫情之后逐渐恢复往常得十一假期, 我把目得地选在了南方得 广西 . 因为要带着老妈出去, 根据以往得经验还是选择一些山清水秀得地区, 行程不累且丰富, 前两个月去了 贵州 , 这下把祖国西南都打卡一下. 我请了两日年假, 旅程安排在9月29日-1月4日, 飞得是国航日津- 桂林 . 出行之前查到了 桂林 一直阴雨连绵得日气预告, 还有丝担心, 落地之后马上被湿热得空气包围了, 仿佛又回到了潮湿得八月.',
            tips:['十一出游','双人行']
        },
        {
            hotel_id:3,
            name:'桂林',

            title: `【心之远方】漫步桂林，看中国最美山水`,
            src: 'https://p1-q.mafengwo.net/s15/M00/2E/33/CoUBGV3D2S2AY7X3AAv2t6Y_HnQ311.JPG?imageMogr2%2Fthumbnail%2F1360x%2Fstrip%2Fquality%2F90',
            description:
                '桂林 一直是 中国 山水的代表，更有“ 桂林 山水甲天下”的美誉，来到一个地方旅游，最重要的就是看这里的文化和景色，如果第一次来 中国 ，去哪里？很简单 文化品“ 北京 ”、景色看“ 桂林 ”。这里一直是我向往的地方，这次我一个人来到 桂林 ，看 中国 最美山水。',
            tips:['单人行','独秀峰','米粉']
        },
        {
            hotel_id:1,
            name:'北京',
            title: `【亲子游】我多想去看看`,
            src: 'http://p1-q.mafengwo.net/s16/M00/D2/D7/CoUBUl_ZYiKANjWJAAlu-VPO1K0250.jpg?imageMogr2%2Fthumbnail%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90',
            description:
                '这个亲子陪伴是个系列，我将持续写下去。'+'一次旅行、一次聚餐、一场电影、一本书、甚至是一通电话......都有可能帮助父母把知识转化成孩子的内生动力。只不过旅行，为孩子们见识外面的世界提供了一个窗口，更能调动他们的好奇心，鼓励着孩子们好好的学习，旅行和学习是相互促进的。',
            tips:['亲子游','一家四口']
        },
        {
            hotel_id:2,
            name:'北京',
            title: `【故宫】逛故宫，那些不可错过的景致`,
            src: 'http://b1-q.mafengwo.net/s17/M00/80/8B/CoUBXl_odKOAdy-0AB3g8MjMUX4979.JPG?imageMogr2%2Fthumbnail%2F1360x%2Fstrip%2Fquality%2F90',
            description:
                '武英不武，书香满溢 在紫禁城前朝西侧，有一座建筑，它见过刀光剑影，闻过醇厚墨香，曾经人迹罕至，也曾门庭若市。它有个威武英气的名字——武英殿',
            tips:['一日游','故宫']
        },
        {
            hotel_id:3,
            name:'北京',

            title: `【秋游】秋天北京是最美的`,
            src: 'https://p1-q.mafengwo.net/s15/M00/2E/33/CoUBGV3D2S2AY7X3AAv2t6Y_HnQ311.JPG?imageMogr2%2Fthumbnail%2F1360x%2Fstrip%2Fquality%2F90',
            description:
                '2020年是紫禁城建成600年，故宫博物院筹备了一次大展，吸引了全国的博物馆爱好者，毕竟珍贵易损的文物不常展出，可谓错过再等一百年。'+'2020年初在天博看了一次京津冀三地壁画展《粉壁丹青》， 北京 法海寺的明代皇家壁画实力种草啊！年初由于突入袭来的新冠疫情，法海寺暂停参观。直到9月22号才恢复参观讲解。'+'两个超级期待的展，值得 北京 去一趟。',
            tips:['秋游','两天','紫禁城']
        },
        {
            hotel_id:1,
            name:'成都',
            title: `【Rainybaby&CL】巴适成都`,
            src: 'http://p1-q.mafengwo.net/s18/M00/D6/72/CoUBYGAxHvuAenjYAA5MFETExXU093.jpg?imageMogr2%2Fthumbnail%2F%21240x160r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21240x160%2Fquality%2F100',
            description:
                '成都，一座来了就不想走的城市，地处全川中心，成都平原沃野千里，依仗都江堰的水利工程，自古以来富足丰饶，拥“天府之国”之美誉；成都有三美：美食、美女、美景，这其中最具有代表性的当然是成都美食，成都美食历史悠久、品种繁多，川菜作为中国八大菜系之一，在烹饪史上占有重要地位，它菜式多样、调味多变、麻辣鲜香、应有尽有。',
            tips:['美食','熊猫','锦里古街']
        },
        {
            hotel_id:2,
            name:'成都',
            title: `【成都乐山】带着孩子看熊猫和大佛`,
            src: 'http://b1-q.mafengwo.net/s17/M00/80/CB/CoUBXl_a-fGAOCt8AAIEGSw5yf810.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                '此时距离出游只有不到1周的时间了，各部门分工，我负责景点，交通以及住宿，我妹妹负责搜罗好吃的，我同时向一些好友咨询 成都 攻略，了解一些景点，就这样赶在出发前，完成了5天4夜的 成都 旅游攻略。先上一些好吃的好玩的好看的吧。',
            tips:['美食','亲子游','乐山']
        },
        {
            hotel_id:3,
            name:'成都',
            title: `【自由行】穿越时光的江湖气`,
            src: 'http://b1-q.mafengwo.net/s12/M00/22/10/wKgED1uaeaWARgp0AANnqQbW6lM26.jpeg?imageMogr2%2Fthumbnail%2F%21240x160r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21240x160%2Fquality%2F90',
            description:
                '很久以来，我一直都想去 成都 转一转，也许是因为一首《 成都 》戳中了我一个『伪文青』的浪漫神经；也许是因为 成都 的美食让我这个『究极吃货』心驰神往；也许是因为 成都 天府之国的美誉，使得饱受摧残的社畜本畜心向往之……'+'总之，在辞职之后第一件事，就是整理行囊，拉上姐妹，向 成都 进发！！',
            tips:['美食','宽窄巷子','双人']
        },
        {
            hotel_id:1,
            name:'上海',
            title: `【亲子游】迪士尼乐园亲子游`,
            src: 'http://n1-q.mafengwo.net/s17/M00/BC/76/CoUBXl-7avGAKTw_ABD971kWBaE63.jpeg?imageMogr2%2Fthumbnail%2F%21345x213r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21345x213%2Fquality%2F90',
            description:
                '2020年，确实是不容易的一年。出行的脚步也被突如其来的疫情所阻滞。还好给小朋友的承诺是：上小学前去一次迪士尼。迪士尼的行程还是比较容易达成的。'+'本来没有准备回来写游记，因为网上攻略特别多，如何玩，线路如何设计，网上都有详细的攻略。不过鉴于周围的妈妈们都强烈要求玩耍的细节。所以有了这篇游记。在这篇游记中，我会尽可能详细的讲一些我所知道的流程以及小贴士，关于我们自己游玩的图可能不会太多，因为主要目的是为了帮助大家。大家看了以后可以根据自己的情况选择适合自己的游玩方式，有不清楚的可以留言问我哦！',
            tips:['迪士尼','亲子游','2天']
        },
        {
            hotel_id:2,
            name:'上海',
            title: `【一日行】城隍庙，外滩，东方明珠，陈列馆，浦江游轮`,
            src: 'http://p1-q.mafengwo.net/s16/M00/CB/89/CoUBUl_ayDWAcjF_AABwiqBmVqw57.jpeg?imageMogr2%2Fthumbnail%2F%21200x150r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21200x150%2Fquality%2F90',
            description:
                ' 上海是一座极具现代化而又不失中国传统特色的都市。外滩老式的西洋建筑与浦东现代的摩天大厦交相辉映；徐家汇大教堂圣诗声声，玉佛寺香烟袅袅；过街楼下的麻将老人，弄堂里的足球少年；群众小剧场的沪剧、滑稽戏，大剧院的交响乐、芭蕾舞；老饭店的本帮佳肴，杏花楼的广式粤茶，红房子的法国大菜；上海老街的茶馆，衡山路的酒吧，中西合璧，各有各精彩。',
            tips:['一日游','游轮','外滩']
        },
        {
            hotel_id:3,
            name:'上海',

            title: `【二刷上海】滴水湖放飞之旅`,
            src: 'http://p1-q.mafengwo.net/s18/M00/36/26/CoUBYGAztneAE4-tAAyFP92AQ64049.jpg?imageMogr2%2Fthumbnail%2F%21240x160r%2Fstrip%2Fgravity%2FCenter%2Fcrop%2F%21240x160%2Fquality%2F100',
            description:
                '22庚子鼠年, 注定是不平凡得一年, 全球在新冠病毒疫情得笼罩下开启了新得一年. 面对突来得疫情 武汉 及时封城, 全国上下支援众志成城, 全民皆兵有序抗疫. 春节假期变成了居家隔离期, 往日熙攘得城市失去了活力, 繁荣得经济放缓了脚步, 多元得社会失去了光彩, 在煎熬得居家隔离岁月里, 时光却也在不经意得流逝.',
            tips:['美食','亲子游']
        },
    ]

};
const mutations = {
    changeOrderHotel(state,obj) {
        state.orderHotel.push(obj)
    },
    addCommentHotel(state,obj) {
        state.commentHotel.push(obj)
    },
    addgoodThidData(state,obj) {
        state.goodThidData.push(obj)
    },
    addCommentGood(state,obj) {
        state.goodData.push(obj)
    },
    addRelated(state,obj) {
        state.dataRelated.push(obj)
    },
    delCommentHotel(state,obj) {
        state.commentHotel = state.commentHotel.filter(item=>{
            return item.comment_id !== obj
        })
    }
};
const actions = {
    actionOrderHotel({commit},obj) {
        commit('changeOrderHotel',obj)
    },
    addCommentGood({commit},obj) {
        commit('addCommentGood',obj)
    },
    addgoodThidData({commit},obj) {
        commit('addgoodThidData',obj)
    },
    addActionCommentHotel({commit},obj) {
        commit('addCommentHotel',obj)
    },
    addActionRelated({commit},obj) {
        commit('addRelated',obj)
    },
    delActionCommentHotel({commit},obj) {
        commit('delCommentHotel',obj)
    }
};
export default {
    state,
    mutations,
    actions
}